import React, { FC, useCallback } from 'react';
import { useUploadFileMutation } from 'redux/apiSlice/storage.slice';
import { compressFormDataImage } from 'helpers/compressImage';
import { SImageUploader } from './ImageUploader.styles';
import { TImageUploaderProps } from './ImageUploader.types';

const ImageUploader: FC<TImageUploaderProps> = props => {
  const [uploadFile, { data }] = useUploadFileMutation();

  const uploadWithCompression = useCallback(
    async (formData: FormData) => {
      const compressed = await compressFormDataImage(formData);
      uploadFile({ file: compressed });
    },
    [uploadFile],
  );

  return (
    <SImageUploader
      uploadFile={uploadWithCompression}
      uploadedImage={data}
      {...props}
    />
  );
};

export default ImageUploader;
